/**
 * FJ Menu Drawer - Horizontal Chip Filtering
 * Handles category filtering via emoji chips in mobile menu
 */

(function() {
  'use strict';

  function matchesCategory(handle, category) {
    if (category === 'alle') return true;
    if (!handle) return false;

    const h = String(handle).toLowerCase();
    if (category === 'fiske') return h.includes('fiske');
    if (category === 'jakt') return h.includes('jakt') || h.includes('hjort') || h.includes('radyr');
    if (category === 'friluftsliv') return h.includes('friluft') || h.includes('tur');
    if (category === 'tilbud') return h.includes('tilbud') || h.includes('kampanje') || h.includes('outlet');
    return h === category;
  }

  // Handle chip filtering
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.menu-chip');
    if (!chip) return;

    document.querySelectorAll('.menu-chip').forEach(c => c.classList.remove('is-active'));
    chip.classList.add('is-active');

    const category = chip.dataset.category;
    const menuItems = document.querySelectorAll('.menu-drawer__menu > li');

    menuItems.forEach(item => {
      const details = item.querySelector('details');
      const categoryHandle = details ? details.id.replace('Details-menu-drawer-collection-', '') : '';
      item.style.display = matchesCategory(categoryHandle, category) ? '' : 'none';
    });
  });

})();
